module.exports = __webpack_public_path__ + "media/images/s2ep7-cindy-755fc94e5e7a9462c1b240f98b640e64.png";